//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
		props:{
			allDay:{
				type:Number,
				default:0
			},
			average:{
				type:Number,
				default:'0'
			},
			averageTime:{
				type:Number,
				default:0
			}
		},
		data() {
			return {
				shangbao:0,
				banjie:0,
				aDay:0,
				pingjun:0,
        averageShi:0,
			};
		},
		watch:{
			allDay:{
				handler(val,old){
				 this.aDay=this.allDay
				},
				deep:true,
				immediate: true
			},
			average:{
				handler(val,old){
				 this.pingjun=this.average
				},
				deep:true,
				immediate: true

			},
			averageTime:{
				handler(val,old){
				 this.averageShi=val
				},
				deep:true,
				immediate: true

			}
		}
	}



// WEBPACK FOOTER //
// ./src/components/zonglan.vue